import type { MouseEventHandler, ReactNode } from 'react'
import { Button, type ZapButtonTone, type ZapButtonVariant } from './Button'

export type DangerActionRowAction = {
  key: string
  label: ReactNode
  icon?: ReactNode
  ariaLabel?: string
  disabled?: boolean
  loading?: boolean
  variant?: ZapButtonVariant
  tone?: ZapButtonTone
  onClick?: MouseEventHandler<HTMLButtonElement>
}

type DangerActionRowProps = {
  title: ReactNode
  description?: ReactNode
  actions: DangerActionRowAction[]
  className?: string
  dangerZone?: boolean
}

export const DangerActionRow = ({
  title,
  description,
  actions,
  className,
  dangerZone = true,
}: DangerActionRowProps) => (
  <article
    className={[
      'settingsCacheBlock',
      'settingsActionRow',
      dangerZone ? 'settingsDangerZone settingsDangerActionRow' : '',
      className ?? '',
    ].filter(Boolean).join(' ')}
  >
    <div className="settingsActionRow__copy">
      <strong>{title}</strong>
      {description ? <p>{description}</p> : null}
    </div>
    <div className="settingsActionRow__actions">
      {actions.map((action) => (
        <Button
          key={action.key}
          variant={action.variant ?? 'secondary'}
          size="sm"
          tone={action.tone ?? (dangerZone ? 'danger' : 'default')}
          icon={action.icon}
          aria-label={action.ariaLabel}
          disabled={action.disabled}
          loading={action.loading}
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      ))}
    </div>
  </article>
)
